import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    // Annotate simple, semantic tables for an accessible mobile card presentation.
    // Keep the original table markup, caption, table headers and desktop layout.
    const headingRow = table.tHead && table.tHead.rows[0];
    const headers = headingRow ? Array.from(headingRow.cells) : [];
    const bodyRows = Array.from(table.tBodies).flatMap(body => Array.from(body.rows));
    const suitable = Boolean(table.closest('#MainContent[data-template^="article"] .blog-post-content, #MainContent .lsg-content-page .page-content')) &&
      headers.length >= 2 && headers.length <= 4 &&
      bodyRows.length > 0 &&
      headers.every(cell => cell.tagName === 'TH' && cell.colSpan === 1 && cell.rowSpan === 1 && cell.textContent.trim()) &&
      bodyRows.every(row => row.cells.length === headers.length &&
        Array.from(row.cells).every(cell => cell.colSpan === 1 && cell.rowSpan === 1));
    if (suitable) {
      const names = headers.map(cell => cell.textContent.trim().replace(/\s+/g, ' '));
      bodyRows.forEach(row => Array.from(row.cells).forEach((cell, i) => {
        cell.dataset.lsgTableLabel = names[i];
      }));
      table.classList.add('lsg-table-stacked');
    }
    if (table.parentElement?.classList.contains('rte-table-wrapper')) return;
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
